// Based off - https://dev.to/flexdinesh/cache-busting-a-react-app-22lk

import { useEffect, useState } from 'react';
import { semverGreaterThan } from './util';

const caches = window.caches || null;

const useCacheBuster = () => {
    const [loading, setLoading] = useState(true);
    const [isLatestVersion, setIsLatestVersion] = useState(false);

    const refreshCacheAndReload = async () => {
        console.log('Clearing cache and hard reloading...');
        // delete browser cache and hard reload
        if (caches) {
            const names = await caches.keys();
            await Promise.all(names.map(name => caches.delete(name)));
        }
        window.location.reload();
    };

    const fetchMetaVersion = () => {
        fetch('/meta.json', {
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        })
            .then(response => response.json())
            .then(meta => {
                const latestVersion = meta.version;
                const currentVersion = process.env.APP_VERSION;

                const shouldForceRefresh = semverGreaterThan(
                    latestVersion,
                    currentVersion
                );

                if (shouldForceRefresh) {
                    console.log(
                        `We have a new version - ${latestVersion}. Should force refresh`
                    );
                    setLoading(false);
                    setIsLatestVersion(false);
                } else {
                    console.log(
                        `You already have the latest version - ${latestVersion}. No cache refresh needed.`
                    );
                    setIsLatestVersion(true);
                    setLoading(false);
                }
            })
            .catch(err => {
                console.error(err);
            });
    };

    useEffect(() => {
        fetchMetaVersion();
    }, []);

    return { loading, isLatestVersion, refreshCacheAndReload };
};

export { useCacheBuster };
